import React from 'react';
import { BatchStatistics } from '../../../types/batch';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

interface Props {
  statistics: BatchStatistics | null;
  runningCount: number;
  onRefresh: () => void;
}

export const BatchDashboard: React.FC<Props> = ({ statistics, runningCount, onRefresh }) => {
  if (!statistics) {
    return (
      <div className="mb-6">
        <div className="text-gray-500">통계 로딩 중...</div>
      </div>
    );
  }

  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">🎯 전체 통계 (최근 30일)</h2>
        <button
          onClick={onRefresh}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2"
        >
          <span>🔄</span>
          <span>새로고침</span>
        </button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* 카드 1: 총 실행 횟수 */}
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">총 실행 횟수</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-3">
              <span className="text-3xl">📊</span>
              <span className="text-3xl font-bold text-gray-900">{statistics.totalExecutions}</span>
              <span className="text-sm text-gray-500">회</span>
            </div>
          </CardContent>
        </Card>

        {/* 카드 2: 성공률 */}
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">성공률</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-3">
              <span className="text-3xl">✅</span>
              <span className="text-3xl font-bold text-green-600">
                {statistics.successRate.toFixed(1)}
              </span>
              <span className="text-sm text-gray-500">%</span>
            </div>
          </CardContent>
        </Card>

        {/* 카드 3: 실패 건수 */}
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">실패 건수</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-3">
              <span className="text-3xl">❌</span>
              <span className="text-3xl font-bold text-red-600">{statistics.failedCount}</span>
              <span className="text-sm text-gray-500">건</span>
            </div>
          </CardContent>
        </Card>

        {/* 카드 4: 실행 중 */}
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">실행 중</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-3">
              <span className="text-3xl">⏳</span>
              <span className="text-3xl font-bold text-blue-600">{runningCount}</span>
              <span className="text-sm text-gray-500">건</span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
